module.exports = __webpack_public_path__ + "static/gallery_kerry_2_thumb-e9bb5131cf87a41237662e3da4978576.jpg";